import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
        height: "50%"
    },
    columnMinWith: {
        minWidth: "5vw"
    },
    columnComment: {
        minWidth: "7vw",
        maxWidth: "25vw",
        whiteSpace: "pre-wrap",
    },
    datePicker: {
        minWidth: "100%",
        marginTop: theme.spacing(2),
    },
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        marginTop: "10px",
    },
    tab: {
        "& .MuiBox-root": {
            padding: "0px",
            paddingTop: "5px",
        },
    },
    numberField: {
        "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            display: "none"
        }
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginTop: "10px",
        //marginLeft: "24px", 
        //marginRight: "24px", 
        marginBottom: "10px",
    },
    zeroPadding: {
        marginLeft: "0px", marginRight: "0px",
        "& .MuiContainer-root": {
            marginLeft: "0px", marginRight: "0px"
        },
    },
    heightScrolledTable: {
        maxHeight: "300px",
    },
    '.test': {
        width: '100%'
    },
}), { index: 1 });
